import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";

import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
Vue.component('vue-draggable-resizable', VueDraggableResizable)

import Default from "./layouts/Default";
import Fullpage from "./layouts/Fullpage";
import Login from "./layouts/Login";

Vue.component("default-layout", Default);
Vue.component("fullpage-layout", Fullpage);
Vue.component("login-layout", Login);

Vue.config.productionTip = false;

// let isInDev = process.env.NODE_ENV !== 'production'
// axios.defaults.baseURL = isInDev ? 'http://localhost/api' : 'https://digitab.com.br/api';
// axios.defaults.baseURL = store.state.serverUrl;

axios.defaults.baseURL = "/api/v1";
if (process.env.ENVIRONMENT === 'dev') {
    axios.defaults.baseURL = "http://localhost:8080/api/v1";
}

axios.interceptors.request.use(
    config => {
        let user = JSON.parse(localStorage.getItem('user'));

        if (user && user.token) {
            config.headers.common["Authorization"] = 'Bearer ' + user.token;
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    response => {
        if (response.status === 200 || response.status === 201) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    }, error => {
        if (error.response.status) {
            switch (error.response.status) {
                case 400:

                    //do something
                    break;

                case 401:
                    // alert("session expired");
                    // router.push({path: '/user/login'})
                    router.replace({
                        path: "/user/login",
                        query: {redirect: router.currentRoute.fullPath}
                    });
                    break;
                case 403:
                    router.replace({
                        path: "/user/login",
                        query: {redirect: router.currentRoute.fullPath}
                    });
                    break;
                case 404:
                    // alert('page not exist');
                    break;
                case 502:
                    setTimeout(() => {
                        router.replace({
                            path: "/user/login",
                            query: {
                                redirect: router.currentRoute.fullPath
                            }
                        });
                    }, 1000);
            }
            return Promise.reject(error.response);
        }
    }
);

// axios.interceptors.response.use(function (response) {
//     return response;
// }, function (error) {
//     if (401 === error.response.status) {
//         router.push({path: '/user/login'})
//     } else {
//         return Promise.reject(error);
//     }
// });
// axios.defaults.baseURL = 'http://127.0.0.1:90';
// axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
// axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.patch['Content-Type'] = 'application/json';
// axios.defaults.headers.patch['Access-Control-Allow-Origin'] = '*';
window.axios = axios;

Vue.use(require('vue-moment'));
// var VueScrollTo = require('vue-scrollto');
// Vue.use(VueScrollTo);

/*var vm = */
new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");

// global.vm = vm; //Define you app variable globally
